import axios from "axios";

// Browser-side → internal Next API → MW
const GET_EXTENDED_WARRANTY_OPTIONS = async (sku) => {
  try {
    const req = await axios.get(`/api/extended-warranty/find/${sku}`);
    return req?.data;
  } catch (error) {
    return error;
  }
};

// Browser-side → internal Next API → MW. Global per-store "more info" HTML for
// the Safeguard popup. Returns the HTML string ("" on any failure / empty).
// Response chain: proxy { data: <MW body>, status }; MW body = { data: { html } }.
const GET_EW_MORE_INFO = async () => {
  try {
    const req = await axios.get(`/api/extended-warranty/more-info`);
    const mwBody = req?.data?.data; // MW body: { data: { html } }
    return mwBody?.data?.html ?? mwBody?.html ?? "";
  } catch (error) {
    return "";
  }
};

const UPDATE_EXTENDED_WARRANTY = async ({
  cart_item_id,
  position,
  extended_warranty_id,
  price_id,
}) => {
  try {
    const body = { cart_item_id, position };
    if (extended_warranty_id !== undefined && extended_warranty_id !== null) {
      body.extended_warranty_id = extended_warranty_id;
    }
    // Send price_id whenever it's provided — INCLUDING null. The BE deselect
    // contract clears a slot via an explicit `price_id: null` (not omission),
    // so only `undefined` is dropped here.
    if (price_id !== undefined) {
      body.price_id = price_id;
    }
    const req = await axios.post(`/api/cart/updateExtendedWarranty`, body);
    return req?.data;
  } catch (error) {
    return error;
  }
};

// Convenience wrapper — clear/deselect a slot.
// BE contract (confirmed with BE dev 2026-06-04): the EW update endpoint is
// update-only and rejects missing IDs, so clearing = send the full fields with
// an explicit `price_id: null` (the valid extended_warranty_id must still be
// present). `null` is sent on the wire — not omitted.
const REMOVE_EXTENDED_WARRANTY = async ({
  cart_item_id,
  position,
  extended_warranty_id,
}) => {
  return UPDATE_EXTENDED_WARRANTY({
    cart_item_id,
    position,
    extended_warranty_id,
    price_id: null,
  });
};

export {
  GET_EXTENDED_WARRANTY_OPTIONS,
  GET_EW_MORE_INFO,
  UPDATE_EXTENDED_WARRANTY,
  REMOVE_EXTENDED_WARRANTY,
};
